import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {PaymentGatewayService} from "../../../serverService/paymentGatewayService/PaymentGatewayService";
import {SnackbarHelper} from "../../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../../context/SnackBarContext";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {
    RaikoAlert,
    raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoToggleOutlined,
    RaikoConfirmDialog
} from "@moeindal/base-raiko-panel-components";

export default function PaymentGatewayMain() {

    const {id: gateWayId} = useParams()

    const service = new PaymentGatewayService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof gateWayId !== 'undefined') {
            service.getGatewayMain(gateWayId)
                .then(response => {
                    setIsMain(response.main)
                    setNewEnabled(response.main)
                }).catch(reason => {
                snackbar.showServerErrorMessage(reason)
            }).finally(_ => {

            })
        }
    }, [gateWayId]);


    const [isMain, setIsMain] = useState(false)
    const [newEnabled, setNewEnabled] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);

    function handleUpdateState() {
        loading.show()
        service.updateGatewayMain(gateWayId, newEnabled)
            .then(response => {
                setIsMain(response.main)
                setOpenDialog(false)

                if (response.main)
                    snackbar.showSuccessMessage("با موفقیت به عنوان درگاه پیشفرض انتخاب شد.")
                else
                    snackbar.showWarningMessage("از درگاه پیشفرض بودن حذف شد.")

            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={openDialog}
                cancelAction={_ => setOpenDialog(false)}
                doAction={handleUpdateState}
                pageTitle={"درگاه اصلی برنامه"}
                warningTitle={"آیا از تغییر وضعیت درگاه اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={isMain ? "حذف پیشفرض" : "انتخاب پیشفرض"}
                cancelButtonTitle={"بیخیال"}
            />
            <RaikoBaseCardContainer className={css`margin-top: 16px;`}>
                <RaikoGridOneColumn>
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            type={raikoAlertTypes.warning}
                            title={"درگاه پرداخت پیشفرض"}
                            description={[
                                "* با فعالسازی این مورد، درگاه پرداخت به عنوان درگاه پرداخت اصلی برنامه انتخاب می شود.",
                                "* درصورتی که درگاه پرداختی در قسمت های مختلف برنامه مشخص نشده باشد از درگاه پرداخت پیشفرض استفاده خواهد شد."
                            ]}
                        />
                        <RaikoToggleOutlined
                            labelText={"درگاه پرداخت پیشفرض"}
                            setChecked={state => {
                                setNewEnabled(state)
                                setOpenDialog(true)
                            }}
                            checked={isMain}
                            id={"gatewayMainToggle"}
                        />
                    </RaikoGridOneColumn>
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </>
    )
}